import React from 'react';

export const inputSwitchingMethods = [
  { value: 'lg_webos', label: 'LG webOS direct API' },
  { value: 'sony_bravia', label: 'Sony BRAVIA direct API' },
  { value: 'android_tv_remote_discrete', label: 'Google TV discrete HDMI key' },
  { value: 'android_tv_remote_input', label: 'Google TV Input button/menu' },
  { value: 'player_home_cec', label: 'Player Home via HDMI-CEC' },
  { value: 'google_assistant', label: 'Google Assistant' },
  { value: 'trained_menu', label: 'Trained input-menu sequence' },
  { value: 'manual', label: 'Manual selection' },
];

const selectable = ['lg_webos', 'trained_menu', 'android_tv_remote_discrete', 'android_tv_remote_input', 'manual'];
const methodLabel = (value) => inputSwitchingMethods.find((method) => method.value === value)?.label || value;

export default function InputSwitchingStrategyEditor({ screen, onChange }) {
  const saved = screen.activationStrategy?.inputSwitching || {};
  const selected = saved.defaultMethod || saved.methods?.[0] || '';
  const choose = (method) => onChange({ ...screen, activationStrategy: { ...screen.activationStrategy,
    inputSwitching: { ...saved, defaultMethod: method,
      methods: [method, ...(saved.methods || []).filter((entry) => entry !== method)].slice(0, 6) } } });
  return <fieldset className="topology-setup__strategy">
    <legend>Input switching</legend>
    <p>Choose the TV input route for this Screen's initial startup. A confirmed Home/CEC shortcut on the target connection takes priority.</p>
    <label>Preferred input route<select value={selected} onChange={(event) => choose(event.target.value)}>
      <option value="">Choose a route</option>
      {selected && !selectable.includes(selected) && <option value={selected}>{methodLabel(selected)} · saved legacy route</option>}
      {selectable.map((method) => <option key={method} value={method}>{methodLabel(method)}</option>)}
    </select></label>
    <p>LG direct selection requires a confirmed reported input on each source connection. Trained menu and supported Google TV routes can select an input. Manual selection requires a person at startup. The routine never blindly retries another input route.</p>
  </fieldset>;
}
